interface Props extends React.PropsWithChildren {
  label: string
  isRequired?: boolean
  name?: string
}

export const Field = ({ name, label, isRequired, children }: Props) => {
  return (
    <div className="w-full space-y-3">
      <label
        htmlFor={name}
        className="font-medium leading-[26px]"
      >
        {label}
        {isRequired && <span className="text-danger-default">*</span>}
      </label>
      {children}
    </div>
  )
}
